import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { firstValueFrom } from 'rxjs'
import { environment } from '@env'
import { Accessory, AccessoryRequest, GetAccessoriesParams, GetAllAccessoriesPagedResponse } from '@models'

@Injectable({
  providedIn: 'root',
})
export class AccessoryService {
  private readonly baseUrl = `${environment.api.baseUrl}/product-structure/v1/accessories`

  constructor(private http: HttpClient) {}

  async getAll(params: GetAccessoriesParams): Promise<GetAllAccessoriesPagedResponse> {
    let httpParams = new HttpParams().set('page', params.page.toString()).set('pageSize', params.pageSize.toString())

    if (params.modelId) httpParams = httpParams.set('modelId', params.modelId)

    if (params.orderBy) httpParams = httpParams.set('orderBy', params.orderBy)

    if (params.order) httpParams = httpParams.set('order', params.order)

    if (params.text) httpParams = httpParams.set('text', params.text)

    if (params.active !== undefined && params.active !== null) httpParams = httpParams.set('active', params.active)

    if (params.itemType) httpParams = httpParams.set('itemType', params.itemType)

    if (params.journey) httpParams = httpParams.set('journey', params.journey)

    if (params.category) httpParams = httpParams.set('category', params.category)

    if (params.product) httpParams = httpParams.set('product', params.product)

    const response = await firstValueFrom(
      this.http.get<GetAllAccessoriesPagedResponse>(this.baseUrl, { params: httpParams })
    )
    return response
  }

  async getById(id: string): Promise<Accessory> {
    const response = await firstValueFrom(this.http.get<Accessory>(`${this.baseUrl}/${id}`))
    return response
  }

  async create(payload: AccessoryRequest): Promise<Accessory> {
    const response = await firstValueFrom(this.http.post<Accessory>(this.baseUrl, payload))
    return response
  }

  async update(id: string, payload: AccessoryRequest): Promise<Accessory> {
    const response = await firstValueFrom(this.http.put<Accessory>(`${this.baseUrl}/${id}`, payload))
    return response
  }

  async delete(id: string): Promise<void> {
    const response = await firstValueFrom(this.http.delete<void>(`${this.baseUrl}/${id}`))
    return response
  }
}
